import { Line, mixins, Bar } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  mounted () {
    if (this.chartData) {
    // this.chartData is created in the mixin
    this.renderChart(this.chartData, {
        scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        scaleFontColor: '#999',
        scaleFontStyle: '600',
        tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        tooltipCornerRadius: 3,
        maintainAspectRatio: false,
        responsive: true,
        maxHeight: '100px',
        animation:false,
        legend: {
            display: false
         },
         scales:{
                yAxes: [{
                  ticks: {
                    beginAtZero : true
                  }
                }]
              }
         
        //  categoryPercentage: 1.0,
        //  barPercentage: 0.2,
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BarChart.js